/**
 * @generated SignedSource<<16ceb52b98514a7346dd29733ae7e258>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type siblingIssueCreateButton_nativeIssueTable$data = {
  readonly issueId: string;
  readonly " $fragmentType": "siblingIssueCreateButton_nativeIssueTable";
};
export type siblingIssueCreateButton_nativeIssueTable$key = {
  readonly " $data"?: siblingIssueCreateButton_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"siblingIssueCreateButton_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "siblingIssueCreateButton_nativeIssueTable",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "issueId"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "6aee15b0398ae80100f4770b20226da4";

export default node;
